import {
    COMPETITION_SECRETARY_FAILURE,
    COMPETITION_SECRETARY_REQUEST,
    COMPETITION_SECRETARY_SUCCESS,
    COMPETITION_SECRETARY_POST_SUCCESS,
    COMPETITION_SECRETARY_DELETE_SUCCESS,
} from 'actions';
import preserveArrayReference from 'utils/Array/preserveArrayReference';

const initialState = {
    data: [],
    isFetched: false,
    isFetching: false,
};

export const competitionSecretaryListReducer = (state = initialState, action) => {
    const {type, data, competitionSecretary} = action;

    switch (type) {
        case COMPETITION_SECRETARY_SUCCESS: {return {
            ...state,
            isFetched: true,
            isFetching: false,
            data: preserveArrayReference(state.data, data),
        }}

        case COMPETITION_SECRETARY_POST_SUCCESS: {return {
            ...state,
            data: [...state.data, competitionSecretary]
        }}

        case COMPETITION_SECRETARY_DELETE_SUCCESS: {
                const newData = state.data.filter(d => d.id !== competitionSecretary)
                return {
                    ...state,
                    data: [...newData]
                }
            }

        case COMPETITION_SECRETARY_REQUEST: {return {
            ...state,
            isFetching: true,
        }}

        case COMPETITION_SECRETARY_FAILURE: {return {
            ...state,
            isFetching: false,
        }}

        default: {return state}
    }
};
